<script>
  import { Chart } from 'chart.js/auto'
  import { onMount, onDestroy } from 'svelte'

  // { labels: [...], datasets: [{ label, data, color? }] }
  let { labels = [], datasets = [], horizontal = false, height = 280 } = $props()

  const PALETTE = ['#3b82f6', '#22c55e', '#f97316', '#a855f7', '#ef4444']

  let canvasEl
  let chart

  const buildConfig = () => ({
    type: 'bar',
    data: {
      labels,
      datasets: datasets.map((dataset, index) => ({
        label: dataset.label,
        data: dataset.data,
        backgroundColor: dataset.color || PALETTE[index % PALETTE.length]
      }))
    },
    options: {
      indexAxis: horizontal ? 'y' : 'x',
      responsive: true,
      maintainAspectRatio: false,
      plugins: { legend: { display: datasets.length > 1 } }
    }
  })

  onMount(() => {
    chart = new Chart(canvasEl, buildConfig())
  })

  $effect(() => {
    if (!chart) return
    chart.data = buildConfig().data
    chart.options.indexAxis = horizontal ? 'y' : 'x'
    chart.update()
  })

  onDestroy(() => chart?.destroy())
</script>

<div style="height: {height}px">
  <canvas bind:this={canvasEl}></canvas>
</div>
